export default __webpack_public_path__ + "static/media/google.a9dec479.png";